<template>
	<div class="office-home container">
		<div v-if="loading" style="min-height: 1000px">
			<div class="row margin-bottom-10 margin-top-20 mybookings-header">
				<div class="col-12">
					<div class="card afas-gold">
						<div class="card-content">
							<h5 class="margin-top-10 margin-bottom-10 white-text">
								Choose a Location
							</h5>
						</div>
					</div>
					<div class="progress">
						<div class="indeterminate"></div>
					</div>
				</div>
			</div>
		</div> 
		<div v-if="!loading">
			<div class="row margin-bottom-10 margin-top-20">
				<div class="col-12">
					<div class="card afas-gold">
						<div class="card-content">
							<h5 class="margin-top-10 margin-bottom-10 white-text">
								Choose an Location
							</h5>
						</div>
					</div>
				</div>
			</div>
			<div class="row locations">
				<div class="col m9">
					<div class="row">
						<!-- DISABLE FITNESS -->
						<div
							class="col m4 location"
							v-for="location in allLocations"
							:key="location.locationid"
						>
							<!-- DISABLE FITNESS -->
							<!-- <div class="col m4 office" v-for="office in allOffices" :key="office.officeid"> -->
							<div class="card">
								<div class="card-image">
									<img
										v-bind:src="
											require(`../assets/images/${location.name }.jpg`)
										"
										height="165px;"
									/>
									<router-link
										class="
											btn-floating
											halfway-fab
											waves-effect waves-light
											afas-gold
											homepage-button
										"
										:to="{
											name: 'Offices',
											params: { locationname: location.name },
										}"
										><i class="material-icons">add</i></router-link
									>
								</div>
								<div class="card-content" style="font-size: 10px">
									<span class="card-title">{{ location.name }}</span>
								</div>
								<div class="card-action">
									<!-- {{ location.plekken }} Desks -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col m3">
					<div class="row">
						<div class="col s12">
							<div class="card afas-blue" style="min-height: 307.5px">
								<div
									class="card-content white-text"
									style="height: 165px"
								>
									<span class="card-title">My Bookings</span>
									<p>See your previous bookings..</p>
								</div>
								<div class="card-action">
									<router-link :to="{ name: 'MyBookings' }"
										><span class="btn white teal-text"
											>My Bookings</span
										></router-link
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
	name: "Locations",
	data() {
		return {
			loading: true,
		};
	},
	computed: mapGetters(["allLocations"]),
	methods: {
		...mapActions(["getAllLocations"]),
		goBack() {
			this.$router.go(-1);
		},
	},
	async created() {
		await this.getAllLocations();
		this.loading = false;
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.homepage-button:hover {
	background-color: #001f52;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations.vue